import React from 'react';
import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import { COLORS } from '../../../theme/themeConstants';
import { useTranslation } from 'react-i18next';

interface AddCategoryButtonProps {
  onClick: () => void;
  onBackClick?: () => void; // optional back button handler
  loading: boolean;
  open: boolean;
  mode: 'itemSubCategory' | 'itemCategory' | 'addStoreCategory';
}

const AddCategoryButton: React.FC<AddCategoryButtonProps> = ({
  onClick,
  loading,
  open,
  mode,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const getButtonText = () => {
    if (open) {
      switch (mode) {
        case 'itemCategory':
          return t('itemCategory.manageItemCategories');
        case 'itemSubCategory':
          return t('itemSubCategory.manageSubCategories');
        case 'addStoreCategory':
          return 'Manage Cuisine List'; // Keep as is for now
        default:
          return '';
      }
    } else {
      switch (mode) {
        case 'itemCategory':
          return t('itemCategory.addItemCategory');
        case 'itemSubCategory':
          return t('itemSubCategory.addSubCategory');
        case 'addStoreCategory':
          return 'Add Store Category (Cuisine)'; // Keep as is for now
        default:
          return '';
      }
    }
  };
  
  const buttonText = getButtonText();

  return (
    <Stack direction="row" spacing={0} sx={{ gap: '16px' }}>
      {mode === 'itemSubCategory' && (
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            navigate(-1);
          }}
          sx={{
            textTransform: 'none',
            borderRadius: 2,
            bgcolor: COLORS.primary.main,
            boxShadow: 'none',
            '&:hover': {
              bgcolor: COLORS.primary.main,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            },
          }}
        >
          {t('itemSubCategory.back')}
        </Button>
      )}
      <Button
        variant="contained"
        size="small"
        startIcon={<Add sx={{ fontSize: 16}} />}
        onClick={onClick}
        disabled={loading}
        sx={{
          textTransform: 'none',
          borderRadius: 2,
          bgcolor: COLORS.primary.main,
          boxShadow: 'none',
          '&:hover': {
            bgcolor: COLORS.primary.main,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        {buttonText}
      </Button>
    </Stack>
  );
};

export default AddCategoryButton;
